import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=f9594c52&"
import script from "./Sustainability.vue?vue&type=script&lang=ts&"
export * from "./Sustainability.vue?vue&type=script&lang=ts&"
import style0 from "./Sustainability.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports